<mbs-modal [title]="'shared:computers.modals.configurePrivileges' | i18next">
  <ng-container modal-body>
    <mbs-alert
      [type]="alertType.warning"
      [icon]="true">
      {{ 'shared:computers.modals.requiredPermissionsTutorial' | i18next }}
    </mbs-alert>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      [type]="'primary'"
      (click)="baseModal.save(true)">
      {{ 'shared:buttons.ok' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
